import script from "./FileDropZone.vue?vue&type=script&setup=true&lang=js"
export * from "./FileDropZone.vue?vue&type=script&setup=true&lang=js"

import "./FileDropZone.vue?vue&type=style&index=0&id=433fbaae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-433fbaae"]])

export default __exports__